import fetch from "./configure";

export const getNewsfeed = params => fetch.get("/getNewsfeed", { params });

// api에 없음
// token , articleIdx , keepType
export const doKeeping = data => fetch.post("/doKeeping", data);
